// src/components/BulkPush.js
import React, { useState } from 'react';
import axios from 'axios';

const BulkPush = () => {
    const [isSending, setIsSending] = useState(false);
    const [message, setMessage] = useState('');

    const sendToAllDevices = async () => {
        setIsSending(true);
        setMessage('');
        try {
            const response = await axios.post('http://localhost:5000/send-global-notification', {
                "title": "🚀 Global Notification",
                "body": "📢 This is a global notification sent to all devices.",
                "image": "https://firebasestorage.googleapis.com/v0/b/youvati.appspot.com/o/Frame%20311.jpg?alt=media&token=80030455-201e-41d3-a31e-b5b2104c3a16" // Optional image URL,
            });
            setMessage('✅ Notification sent to all devices!');

        } catch (error) {
            console.error("Global notification error:", error);
            setMessage('❌ Failed to send notification.');
        }
        setIsSending(false);
    };

    return (
        <div style={{ padding: '20px' }}>
            <h1>Send to All Devices</h1>
            <button onClick={sendToAllDevices} disabled={isSending}>
                {isSending ? 'Sending...' : 'Send Global Notification'}
            </button>
            {message && <p>{message}</p>}
        </div>
    );
};

export default BulkPush;


// // src/components/BulkPush.js
// import React, { useState } from 'react';
// import axios from 'axios';

// const BulkPush = () => {
//     const [phoneNumbers, setPhoneNumbers] = useState(['7856946583']);
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [isSending, setIsSending] = useState(false);

//     const sendNotificationsSequentially = async () => {
//         setIsSending(true);
//         for (let i = 0; i < phoneNumbers.length; i++) {
//             const phoneNo = phoneNumbers[i];
//             try {
//                 await axios.post('http://localhost:5000/send-notification', { phoneNo });
//                 setCurrentIndex(i + 1);
//                 await new Promise((resolve) => setTimeout(resolve, 2000)); // 2-second delay
//             } catch (error) {
//                 console.error(`Error sending notification to ${phoneNo}:`, error);
//             }
//         }
//         setIsSending(false);
//     };

//     return (
//         <div>
//             <h1>Send Notifications</h1>
//             <ul>
//                 {phoneNumbers.map((phone, index) => (
//                     <li key={phone}>
//                         Phone: {phone}{' '}
//                         {index < currentIndex ? (
//                             <span style={{ color: 'green' }}>✔️</span>
//                         ) : (
//                             <span style={{ color: 'gray' }}>⏳</span>
//                         )}
//                     </li>
//                 ))}
//             </ul>
//             <button onClick={sendNotificationsSequentially} disabled={isSending}>
//                 {isSending ? 'Sending...' : 'Send Notifications'}
//             </button>
//         </div>
//     );
// };

// export default BulkPush;